<script lang="ts">
  export let timestamp;

  const time = new Date(timestamp);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ]

  let formattedMinutes = "" + time.getMinutes();
  if (time.getMinutes() < 10) {
    formattedMinutes = "0" + time.getMinutes();
  }

  let fullTimestamp = `${months[time.getMonth()]} ${time.getDate()} ${time.getFullYear()} `;
  if (time.getHours() < 12) {
    fullTimestamp += `${time.getHours()}:${formattedMinutes} AM`;
  } else {
    fullTimestamp += `${time.getHours() - 12}:${formattedMinutes} PM`;
  }

</script>

<div class="timestamp" title={fullTimestamp}>
  <div class="month">{ months[time.getMonth()] }</div>
  <div class="date"> { time.getDate() }</div>
  <!-- <div class="year">{ time.getFullYear() }</div> -->
  <!-- <div class="time">{`${time.getHours() > 12 ? time.getHours() - 12 : time.getHours()}:${time.getMinutes()}`}</div> -->
</div>

<style>
  .timestamp {
    display: block;
    font-size: 0.75rem;
    color: #999;
    text-align: center;
    padding: 0 0.25rem;
  }

  .date {
    font-size: 1.3rem;
    line-height: 1.2rem;
    font-weight: bold;
  }
</style>
